<template>
  <div class="container">
    <div class="loading" v-if="fetchData">
      <load-data></load-data>
    </div>
    <div v-if="!fetchData">
      <div>
        <b-row>
          <b-col sm="12">
            <b-form-group>
              <div class="" style="text-align:right;">
                <div>
                  <b-button v-if="!editMode" @click="editMode = true" type="submit" variant="primary" size="md">Edit
                  </b-button>
                </div>
              </div>
            </b-form-group>

            <table class="table  table-striped table-bordered">
              <tr>
                <th>
                  Planned No. of hours
                </th>
                <th>
                  <b-form-input v-if="editMode" placeholder="No. of hours" type="number" v-model="planned_houres">
                  </b-form-input>
                  <span v-else>
                    {{ planned_houres }}
                  </span>
                </th>
              </tr>
            </table>

            <table class="table  table-striped table-bordered">
              <tr>
                <th>
                  SI. No.
                </th>
                <th>
                  Name
                </th>
                <th>
                  <div class="d-flex align-items-center">
                    <span class="mr-1">Threshold (%)</span>
                    <span
                      v-b-popover.click.blur="'Student should have obtained this minimum attendance percentage to be considered for leave.'"
                      title="Threshold"
                      tabindex="0" style="cursor:pointer; color:#17a2b8; font-size:1.1rem; line-height:1; outline:none;"
                    ><b-icon icon="info-circle-fill"></b-icon></span>
                  </div>
                </th>
                <th>
                  Limit By
                </th>
                <th>
                  <div class="d-flex align-items-center">
                    <span class="mr-1">Limit</span>
                    <span
                      v-b-popover.click.blur="'Any leave until the entered count or percentage will be considered as present. Leave exceeding the entered count or percentage will be considered as absent in the final attendance report total count and percentage.'"
                      title="Limit"
                      tabindex="0" style="cursor:pointer; color:#17a2b8; font-size:1.1rem; line-height:1; outline:none;"
                    ><b-icon icon="info-circle-fill"></b-icon></span>
                  </div>
                </th>
              </tr>
              <tbody v-for="(atttype, reindex) in attendancetypes" :key="reindex">
                <tr>
                  <td>{{ reindex + 1 }}</td>
                  <td>
                    {{ atttype.name }}
                  </td>
                  <td>
                    <b-form-input v-if="editMode" placeholder="Threshold" type="number"
                      v-model="attendanceTypeLimits[atttype.id].threshold"></b-form-input>
                    <span v-else>{{ attendanceTypeLimits[atttype.id].threshold }}</span>
                  </td>
                  <td>
                    <b-form-select v-if="editMode" :options="limitByOptions"
                      v-model="attendanceTypeLimits[atttype.id].limit_by"></b-form-select>
                    <span v-else>{{ attendanceTypeLimits[atttype.id].limit_by }}</span>
                  </td>
                  <td>
                    <b-form-input v-if="editMode"
                      :placeholder="attendanceTypeLimits[atttype.id].limit_by ? 'Limit ' + attendanceTypeLimits[atttype.id].limit_by : 'Limit'"
                      type="number"
                      v-model="attendanceTypeLimits[atttype.id].value"></b-form-input>
                    <span v-else>{{ attendanceTypeLimits[atttype.id].value }}{{ attendanceTypeLimits[atttype.id].limit_by === 'Percentage' ? '%' : '' }}</span>
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="table table-striped table-bordered">
              <tr>
                <th>Rounding</th>
                <td>
                  <b-form-radio-group v-if="editMode" v-model="rounding" :options="[{ text: 'Up', value: 'up' }, { text: 'Down', value: 'down' }]" />
                  <span v-else>{{ rounding ? rounding.charAt(0).toUpperCase() + rounding.slice(1) : '-' }}</span>
                </td>
              </tr>
            </table>

            <b-form-group>
              <div class="" style="text-align:right;">
                <div>
                  <b-button v-if="editMode" @click="updateCourse()" type="submit" variant="primary" size="md"
                    :disabled="additionalBtn.disabled">{{ additionalBtn.text }}</b-button>
                </div>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["courseInfo"],
  async created() {
    this.fetchData = true;

    await this.$set(this.course, "name", this.courseInfo.name);
    await this.$set(this.course, "code", this.courseInfo.code);
    this.$set(
      this.course,
      "attendance_type_limits",
      this.courseInfo.property.attendance_type_limits
    );
    this.planned_houres = this.courseInfo.property.planned_houres;
    this.rounding = this.courseInfo.property.attendance_type_limits?.rounding ?? null;
    await this.getAttendanceTypes();

    this.fetchData = false;
  },
  data() {
    return {
      fetchData: true,
      course: {},
      editMode: false,
      attendancetypes: [],
      attendanceTypeLimits: {},
      limitByOptions: ['Percentage', 'Count'],
      rounding: null,
      planned_houres: null,
      additionalBtn: {
        text: "Submit",
        disabled: false,
      },
    };
  },
  methods: {
    async updateCourse() {
      const invalid = Object.values(this.attendanceTypeLimits).some(
        (limit) => limit.value !== null && limit.value !== '' && Number(limit.value) !== 0 && !limit.limit_by
      );
      if (invalid) {
        this.$toast.error("Limit By cannot be empty", {
          position: "top",
          duration: 3000,
        });
        return;
      }
      this.additionalBtn.text = "Please Wait...";
      this.additionalBtn.disabled = true;
      this.course.attendance_type_limits = { ...this.attendanceTypeLimits, rounding: this.rounding };
      this.course.planned_houres = this.planned_houres;
      const url =
        this.$store.getters.getAPIKey.updateCourse.replace(
          "course_id",
          this.courseInfo.id
        ) + `?course_property=1`;

      await this.$axios
        .put(url, this.course)
        .then(() => {
          this.$toast.success("Updated successfully", {
            position: "top",
            duration: 3000,
          });
          this.editMode = false;
          this.$emit("CourseUpdated");
        })
        .catch(() => {
          this.$toast.error("Failed to update", {
            position: "top",
            duration: 3000,
          });
        });
      this.additionalBtn.text = "Submit";
      this.additionalBtn.disabled = false;
    },

    async getAttendanceTypes() {
      // this.fetchData = true;
      const url = this.$store.getters.getAPIKey.attendenceType;
      await this.$axios.get(url).then((response) => {
        let attendanceTypes = response.data;
        attendanceTypes
          .filter((attendenceType) => !['Present', 'Absent'].includes(attendenceType.name))
          .forEach((attendenceType) => {
          this.attendancetypes.push({
            id: attendenceType.id,
            name: attendenceType.name,
          });
          const saved = this.course.attendance_type_limits?.[attendenceType.id];
          this.$set(this.attendanceTypeLimits, attendenceType.id, {
            value: saved?.value ?? null,
            limit_by: saved?.limit_by ?? null,
            threshold: saved?.threshold ?? null,
          });
          // this.attendanceTypesObjects[attendenceType.id] = attendenceType;
        });
      });
    },
  },
};
</script>
